import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { Params, RouterLink } from '@angular/router';
import { AdminUserType, SvgIcon, ProviderInfoStatus } from '@k12/models';
import { SvgIconComponent } from '@k12/ui-primitives';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
interface UserInfoHeaderEmployee {
    type?: string | null;
}

interface UserInfoHeaderData {
  provider?: string | null;
  type?: string | null;
  status?: string | null;
  verified?: boolean | null;
  address?: string | null;
  employees?: UserInfoHeaderEmployee[] | null;
}

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'lib-user-info-header',
  imports: [CommonModule, SvgIconComponent, MatButtonModule, MatIconModule, MatSelectModule, MatIconModule, MatTooltipModule, RouterLink],
  templateUrl: './user-info-header.component.html',
  styleUrl: './user-info-header.component.scss'
})
export class UserInfoHeaderComponent {
  @Input() data: UserInfoHeaderData | null = null;
  @Input() detailsExpanded: boolean = false;
  @Input() editing: boolean = false;
  @Input() messageCenter: boolean = false;
  @Input() isArchived: boolean = false;
  @Input() userType: AdminUserType = AdminUserType.Provider;
  @Input() detailLink: string[] | null = null;
  @Input() detailQueryParams: Params | null = null;
  @Output() cbEdit = new EventEmitter();
  @Output() cbSave = new EventEmitter();
  @Output() cbExpand = new EventEmitter();

  blueCheckIcon = SvgIcon.BlueCheck;
  editIcon = SvgIcon.Edit;

  toggleEdit() {
    if (!this.messageCenter) {
      this.editing = !this.editing;
    }
    this.cbEdit.emit();
  }

  toggleExpand() {
    this.detailsExpanded = !this.detailsExpanded;
    this.cbExpand.emit();
  }

  toggleSave() {
    if (!this.messageCenter) {
      this.editing = !this.editing;
    }
    this.cbSave.emit();
  }

  getAddressWithLineBreaks(address?: string | null): string {
    return address ? address.replace(/\n/g, '<br>') : '';
  }

  getTherapyEmployeeLength(employees?: UserInfoHeaderEmployee[] | null): number {
    if (!employees) {
      return 0;
    }

    return employees.filter((employee) => employee.type === 'Therapy').length;
  }

  getTutoringEmployeeLength(employees?: UserInfoHeaderEmployee[] | null): number {
    if (!employees) {
      return 0;
    }

    return employees.filter((employee) => employee.type === 'Tutoring').length;
  }

  getStatusBadgeClass(status: string | null | undefined): string {
    switch (status) {
      case ProviderInfoStatus.InReview:
        return 'in-review';
      case ProviderInfoStatus.Approved:
        return 'approved';
      case ProviderInfoStatus.Rejected:
      case ProviderInfoStatus.ClassWallet:
        return 'rejected';
      case ProviderInfoStatus.InPerson:
        return 'in-person';
      default:
        return 'in-review';
    }
  }
}
